/* eslint-disable no-nested-ternary */
import React from 'react';
import useWindowResize from '../../hooks/useWindowSize';

const withWindowResize = Component => props => <Component {...props} width={useWindowResize()} />;

export default withWindowResize;
